import { ScreenNamesInterface } from './types';

export enum ScreenNameEnums {
  JOB_REQUISITIONS,
  JOB_REQUISITIONS_VIEW,
  CANDIDATE,
  CANDIDATE_APPLICATION_STATUS,
  CANDIDATE_INTERVIEW_STATUS,
  CANDIDATE_ONBOARDING,
  INTERVIEW_CANDIDATE_VIEW,
  PRE_ONBOARDING,
  CANDIDATE_PRE_ONBOARDING,
}

export const ScreenNames: ScreenNamesInterface = {
  JOB_REQUISITIONS: 'Job Requisitions',
  JOB_REQUISITIONS_VIEW: 'Job Requisitions',
  CANDIDATE: 'Candidates',
  CANDIDATE_APPLICATION_STATUS: 'Application Status',
  CANDIDATE_INTERVIEW_STATUS: 'Interview Status',
  CANDIDATE_ONBOARDING: 'Onboarding Status',
  PRE_ONBOARDING: 'Pre-Onboarding Status',
  CANDIDATE_PRE_ONBOARDING: 'Pre-Onboarding Status',
  INTERVIEW_CANDIDATE_VIEW: 'Interview',
};
